import script from "./Tlogin.vue?vue&type=script&setup=true&lang=js"
export * from "./Tlogin.vue?vue&type=script&setup=true&lang=js"

import "./Tlogin.vue?vue&type=style&index=0&id=c75253f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c75253f4"]])

export default __exports__